/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Pick_Portal_HintInputs */

const cs_pm_pick_portal_hint = /** @type {(inputs: Pm_Pick_Portal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality (a kompatibilní portály) načteme přes API vaším účtem. U ostatních nahrajte export inzerátů (JSON nebo CSV).`)
};

const en_pm_pick_portal_hint = /** @type {(inputs: Pm_Pick_Portal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality (and compatible portals) are read over the API with your account. For others, upload a listing export (JSON or CSV).`)
};

/**
* | output |
* | --- |
* | "Sreality (and compatible portals) are read over the API with your account. For others, upload a listing export (JSON or CSV)." |
*
* @param {Pm_Pick_Portal_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_pick_portal_hint = /** @type {((inputs?: Pm_Pick_Portal_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Pick_Portal_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_pick_portal_hint(inputs)
	return cs_pm_pick_portal_hint(inputs)
});